module.exports = __webpack_public_path__ + "static/img/2.2.dfc1e38.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/4/eng/2.2.png
// module id = SXYA
// module chunks = 0